import { useState } from "react";
import { UnitsDescriptionRead } from "@types";

export function useManageUnitDescription() {
  const [selectedSize, setSelectedSize] = useState<UnitsDescriptionRead | null>(
    null,
  );
  const [isSideBarOpen, setIsSideBarOpen] = useState<boolean>(false);
  const [unitDescriptionToDeleteId, setUnitDescriptionToDeleteId] =
    useState<string>("");
  const [isDetailsModalOpen, setIsDetailsModalOpen] = useState(false);

  const toggleSideBar = () => {
    setSelectedSize(null);
    setIsSideBarOpen((prev) => !prev);
  };

  const selectSizeToEdit = (Size: UnitsDescriptionRead) => {
    setIsSideBarOpen(true);

    setSelectedSize(Size);
  };

  const handleCloseDetailsModal = () => {
    setIsDetailsModalOpen(false);
    setSelectedSize(null);
  };

  const handleRowClick = (rowData: { data: UnitsDescriptionRead }) => {
    setSelectedSize(rowData.data);
    setIsDetailsModalOpen(true);
  };

  const handlePressDeleteButton = (id: string) => {
    setUnitDescriptionToDeleteId(id);
  };

  const handleCloseDeleteDialog = () => {
    setUnitDescriptionToDeleteId("");
  };

  return {
    selectedSize,
    isSideBarOpen,
    isDetailsModalOpen,
    unitDescriptionToDeleteId,
    setSelectedSize,
    toggleSideBar,
    selectSizeToEdit,
    handleRowClick,
    handleCloseDetailsModal,
    handlePressDeleteButton,
    handleCloseDeleteDialog,
  };
}
